export default __webpack_public_path__ + "static/media/regulatory--maximum-speed-limit-led-90--g1.be1d5ec8.png";